import {on, findAll, findIn, closest} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

const selectors = {
    inputWrapper: ".js-link-inputs",
    input: ".js-link-inputs__input",
}

export function init () {
    onFind(selectors.inputWrapper, function (element) {
        let input = findIn(selectors.input, element);
        let inputs = findAll(selectors.input);
        let inputVal;

        on("change", function (element) {
            if(element.target.type == "number") {
                inputVal = input.value;
                inputs.map(function(item) {
                    if(item !== element.target) {
                        item.value = inputVal;

                        let decreaseBtns = findAll(".js-number-spinner__down");
                        if(inputVal > 1) {
                            decreaseBtns.map(function (item) {
                               item.disabled = false;
                            });
                        } else {
                            decreaseBtns.map(function (item) {
                                item.disabled = true;
                            });
                        }
                    }
                });
            } else if(element.target.type == "radio") {
                inputVal = input.value;
                inputs.map(function(item) {
                    if(item !== element.target) {
                        if(item.value === inputVal) {
                            item.checked = true;
                        }
                    }
                });
            }
        }, input);
    });
}